import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { AplicacionesTransporteComponent } from "./aplicaciones-transporte.component";
import { AplicacionesTransporteService } from "./aplicaciones-transporte.service";
import { DataFilterPipe, DataFilterPipe2, DataFilterPipe3, DataFilterPipe4 } from "./aplicaciones-transporte.filter";
import { AplicacionesTransporteConsultaComponent } from "./aplicaciones-transporte-consulta.component";
import { CalendarModule } from 'primeng/primeng';

@NgModule({
    declarations: [AplicacionesTransporteComponent, DataFilterPipe, DataFilterPipe2, DataFilterPipe3, DataFilterPipe4, AplicacionesTransporteConsultaComponent],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        CalendarModule],
    providers: [AplicacionesTransporteService],
    exports: [AplicacionesTransporteComponent]
})

export class AplicacionesTransporteModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte.module.ts